<template>
    <div>
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
        <b-card style="margin: 20px">
            <b-card-header header-tag="header" class="p-1" role="tab">Filtros</b-card-header>
            <b-card-body>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-6">
                        <label>Fecha desde</label>
                        <br />
                        <KitsDate v-model="modelo.FechaDesde" :currentValue="modelo.FechaDesde" />
                    </div>
                    <div class="col-md-6">
                        <label>Fecha hasta</label>
                        <br />
                        <KitsDate v-model="modelo.FechaHasta" :currentValue="modelo.FechaHasta" />
                    </div>
                </div>
                <div class="row" style="margin-top: 10px">
                    <div class="col-md-12">
                        <filter-button @click="filtrar"></filter-button>
                    </div>
                </div>
            </b-card-body>
        </b-card>
        <b-card style="margin:10px 20px;">
            <b-card-body>
                <tabs fill class="flex-column flex-md-row">
                    <card shadow>
                        <tab-pane>
                            <span slot="title">Facturas</span>
                            <div v-if="modelo.Facturas.length > 0">
                                <div class="row" style="margin:10px 20px;" v-for="item in modelo.Facturas" v-bind:key="item.EntityID">
                                    <div class="col-2">
                                        <b>Fecha:</b> {{item.FormattedReceiptDate}}
                                    </div>
                                    <div class="col-2">
                                        <b>Tipo:</b> {{item.ReceiptType}}
                                        <span v-if="item.IsParentInvoice" class="badge badge-info" style="margin-left:5px;">Facturado al padre</span>
                                    </div>
                                    <div class="col-3">
                                        <b>Número:</b> {{item.ReceiptDescription}}
                                    </div>
                                    <div class="col-3">
                                        <b>Importe:</b> $ {{item.FormattedAmount}}
                                    </div>
                                    <div class="col-2">
                                        <button class="btn btn-success btn-sm"
                                            @click="descargarComprobante(item.EntityID)">
                                            <i class="fa fa-fw fa-download"></i> Descargar
                                        </button>
                                    </div>
                                    <div v-if="item.IsParentInvoice" class="col-12">
                                        <small class="text-muted">Corresponde a la porción de tus movimientos facturada en el comprobante emitido a tu comercio padre.</small>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col-12 text-center">
                                        <img src="@/assets/ic_no_resultado.png" />
                                    </div>
                                    <div class="col-12 text-center">No se encontraron registros</div>
                                </div>
                            </div>
                        </tab-pane>
                        <tab-pane>
                            <span slot="title">Retenciones</span>
                            <div v-if="modelo.Retenciones.length > 0">
                                <div class="row" style="margin:10px 20px;" v-for="item in modelo.Retenciones" v-bind:key="item.EntityID">
                                    <div class="col-2">
                                        <b>Fecha:</b> {{item.FormattedReceiptDate}}
                                    </div>
                                    <div class="col-3">
                                        <b>Tipo:</b> {{item.ReceiptType}}
                                    </div>
                                    <div class="col-3">
                                        <b>Número:</b> {{item.CertificateNumber}}
                                    </div>
                                    <div class="col-2">
                                        <b>Importe:</b> $ {{item.FormattedAmount}}
                                    </div>
                                    <div class="col-2">
                                        <button class="btn btn-success btn-sm"
                                            @click="descargarRetencion(item.EntityID)">
                                            <i class="fa fa-fw fa-download"></i> Descargar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col-12 text-center">
                                        <img src="@/assets/ic_no_resultado.png" />
                                    </div>
                                    <div class="col-12 text-center">No se encontraron registros</div>
                                </div>
                            </div>
                        </tab-pane>
                    </card>
                </tabs>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
    import axiosHelpers from "@/helpers/axiosHelpers";
    import datetimeHelpers from "@/helpers/datetimeHelpers";
    import notificationHelpers from "@/helpers/notificationHelpers";
    import KitsDate from "@/components/KitsDate";
    import FileHelper from 'fwkits-core-presentation-vue/helpers/fileHelpers';

    export default {
        components: { KitsDate },
        data() {
            return {
                modelo: {
                    FechaDesde: '',
                    Fechahasta: '',
                    Facturas: [],
                    Retenciones: []
                }       
            }
        },
        mounted () {
            this.modelo.FechaDesde = datetimeHelpers.getMonthStart();
            this.modelo.FechaHasta = datetimeHelpers.getNextDay();
        },
        methods: {
            filtrar() {
                let contexto = this;
                if (contexto.modelo.FechaDesde == '') {
                    notificationHelpers.showError('Error', 'La fecha desde es requerida', this);
                    return;
                }

                if (contexto.modelo.FechaHasta == '') {
                    notificationHelpers.showError('Error', 'La fecha hasta es requerida', this);
                    return;
                }

                if (datetimeHelpers.compareFromTo(contexto.modelo.FechaDesde, contexto.modelo.FechaHasta)) {
                    notificationHelpers.showError('Error', 'La fecha desde no puede ser mayor a la fecha hasta', this);
                    return;
                }

                if (datetimeHelpers.compareDifference(contexto.modelo.FechaDesde, contexto.modelo.FechaHasta, 740)) {
                    notificationHelpers.showError('Error', 'Rango entre fechas demasiado extenso, intente con un rango menor', this);
                    return;
                }

                let solicitud = { DateFrom: contexto.modelo.FechaDesde, DateTo: contexto.modelo.FechaHasta };

                axiosHelpers.axiosPost("Account/GetElectronicReceipts", solicitud, this, function(data) {
                    contexto.modelo.Facturas = data.ResponseVM.Receipts;
                });

                axiosHelpers.axiosPost("Account/GetRetentionReceipts", solicitud, this, function(data) {
                    contexto.modelo.Retenciones = data.ResponseVM.Receipts;
                });
            },
            descargarComprobante(receiptID) {
                axiosHelpers.axiosPost("Account/GetElectronicReceiptReport", { EntityID: receiptID }, this, function (data) {
                    if (data.ResponseVM.HasErrors == true) {
                        return;
                    }
                    
                    FileHelper.downloadFile(this, data.ResponseVM.FileContent, data.ResponseVM.FileName, 'data:application/pdf');
                });
            },
            descargarRetencion(receiptID) {
                axiosHelpers.axiosPost("Account/GetRetentionReceiptReport", { EntityID: receiptID }, this, function (data) {
                    if (data.ResponseVM.HasErrors == true) {
                        return;
                    }
                    
                    FileHelper.downloadFile(this, data.ResponseVM.FileContent, data.ResponseVM.FileName, 'data:application/pdf');
                });
            }
        },
    }
</script>